import type { QueueViewKey } from '../../../types/encounterWork';

/**
 * The ids and keys that make Home's summary strip an ARIA tablist
 * (GDN-4085): one panel, labelled by whichever tile is selected, and the
 * keys that move between tiles.
 */

export const HOME_QUEUE_PANEL_ID = 'home-queue-panel';

export const homeQueueTabId = (key: QueueViewKey): string => `home-queue-tab-${key}`;

/** The tab a key press moves to, or null for a key the tablist does not handle. */
export const nextTabIndex = (key: string, index: number, count: number): number | null => {
  switch (key) {
    case 'ArrowRight':
      return (index + 1) % count;
    case 'ArrowLeft':
      return (index - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
};
